import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { ProjectTemplateSpace } from '../types';
import { useActiveTemplateId } from './use-active-project-template';

const getProjectTemplateSpace = () =>
  createSelector(
    (state: RootState) => state.templates.project.data,
    (_, { spaceId, templateId }) => ({ spaceId, templateId }),
    (data, { spaceId, templateId }) => {
      return data?.[templateId]?.spaceList?.[spaceId];
    },
  );

export const useProjectTemplateSpace = (
  spaceId: number,
): ProjectTemplateSpace | undefined => {
  const templateId = useActiveTemplateId();
  const spaceObject = useMemo(() => getProjectTemplateSpace(), []);

  return useSelector((state: RootState) =>
    spaceObject(state, { spaceId, templateId }),
  );
};
